import Repository from "./RepositoryFactoryMain";
const ADD_ORDERRETURN = "add";
const UPDATE_ORDERRETURN = "update";
const GET_ORDERRETURN = "get";

export default {
  addOrderReturn(payload) {
    return Repository.post(transformRoute(ADD_ORDERRETURN), payload);
  },
  updateOrderReturn(payload) {
    return Repository.post(transformRoute(UPDATE_ORDERRETURN), payload);
  },
  getOrderReturn(payload) {
    return Repository.post(transformRoute(GET_ORDERRETURN), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/orderReturn/${route}`;
};
